import React, { useContext, useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  Chip,
  Fab,
  Button,
  Fade,
  makeStyles
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import ProductsForm from "../Products/ProductsForm";
import { useParams } from "react-router-dom";
import { Context as ItemsContext } from "../../context/ItemsContext";
import { store } from "react-notifications-component";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    padding: theme.spacing(3),
    borderTopColor: theme.palette.secondary.light,
    borderTop: "12px solid",
  },
  fab: {
    position: "relative",
    float: "right",
  },
  row: {
    display: "flex",
    marginBottom: 8,
  },
  dataContainer: {
    marginBottom: 25,
  },
  imageContainer: {
    height: "250px",
    display: "flex",
    alignItems: "center",
    justifyContent:"center",
  },
  image: {
    height: "100%",
    borderRadius: 5,
    border: "1px solid lightgray",
  }
}));

const Product = ({ history }) => {
  const { id } = useParams();
  const classes = useStyles();

  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [keyForm, setKey] = useState(1);
  const [product, setProduct] = useState({
    name: "Product",
    units: 0,
    unitPrice: 0,
    description: "",
    url: "",
  });

  const {
    state: { items, folders, error },
    updateItem,
  } = useContext(ItemsContext);

  useEffect(() => {
    const foundProduct = items.find((p) => p.id === id);
    if (foundProduct) {
      setProduct(foundProduct);
    } else {
      history.push("/products");
    }
  }, [product, id, items, history]);

  const handleSubmission = async (productUpdated) => {
    setLoading(true);
    const madeChanges = hadChanges(product,productUpdated);
    if(madeChanges){
      productUpdated.id = product.id;
      const response = await updateItem(productUpdated);
      if (response) {
        setKey(keyForm + 1);
        store.addNotification({
          title: "¡Éxito!",
          message: "Producto actualizado.",
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animated", "fadeIn"],
          animationOut: ["animated", "fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true,
          },
        });
        setIsEditing(false);
      }
    }
    else{
      setIsEditing(false);
    }
    setLoading(false);
  };

  const hadChanges = (prevProduct, newProduct)=>{
    if(prevProduct.name !== newProduct.name)
      return true;
    if(prevProduct.unitPrice !== newProduct.unitPrice)
      return true;
    if(prevProduct.folder !== newProduct.folder)
      return true;
    if(prevProduct.description !== newProduct.description)
      return true;
    return newProduct.editedFile;
  }

  const renderErrors = error.split("\n").map((e, index) => {
    if (e.trim().length > 0) {
      return <Chip key={index} className={classes.errors} label={e} />;
    }
    return null;
  });

  return (
    <Fade in>
      <Paper className={classes.root}>
        <Fab
          color="secondary"
          aria-label="edit"
          className={classes.fab}
          onClick={() => setIsEditing((prev) => !prev)}
        >
          <EditIcon />
        </Fab>
        {isEditing ? (
          <ProductsForm
            product={product}
            loading={loading}
            submitText="Update Item"
            headerText="Update Item"
            folders={folders}
            errors={renderErrors}
            onSubmit={handleSubmission}
          />
        ) : (
          <Grid container justifyContent="space-around" spacing={2}>
            <Grid item xs={12} md={4} className={classes.dataContainer}>
              <Grid item xs={12} className={classes.row}>
                <Typography variant="h5" component="h5" style={{wordBreak:"break-all"}}>
                  {product.name}
                </Typography>
              </Grid>
              <Grid item xs={12} className={classes.row}>
                <Chip color="primary" label={`Categoría: ${product.folder}`} />
              </Grid>
              <Grid item xs={12} className={classes.row}>
                <Typography
                  variant="button"
                  component="div">
                  Puntos: {product.unitPrice}
                </Typography>
              </Grid>
              <div>
                <Typography variant="button" component="p">
                  Descripción:
                </Typography>
                
                <div
                  style={{ marginLeft: 20, width:"90%", wordBreak:"break-all" }}
                >
                  {product.description}
                  
                </div>
              </div>
            </Grid>
            <Grid item xs={12} md={5} className={classes.imageContainer}>
              <img alt="product" className={classes.image} src={product.url} />
            </Grid>
          </Grid>
        )}
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => history.goBack()}
        >
          Go Back
        </Button>
      </Paper>
    </Fade>
  );
};
export default Product;
